export default class DownloadArgsHelper {
  constructor(selectedFormat, formatType, resolutionX, resolutionY) {
    this.selectedFormat = selectedFormat;
    this.formatType = formatType;
    this.resolutionX = resolutionX;
    this.resolutionY = resolutionY;
  }

  setFrn(frn) {
    this.frn = frn;
  }

  getFrn() {
    return this.frn;
  }

  setRrn(rrn){
    this.rrn = rrn;
  }

  getRrn() {
    return this.rrn;
  }
}